module.exports = __webpack_public_path__ + "img/usa.46b96658.jpg";